<div class="db-payment-button" *ngIf="(userSubscription?.trialClient
 && !(userSubscription?.status === userSubscriptionStatus.expired
 || userSubscription?.status === userSubscriptionStatus.failed
 || userSubscription?.status === userSubscriptionStatus.canceled
|| userSubscription?.isExpired)) && !userSubscription?.recharge"
     [ngClass]="{'canceled': ([userSubscriptionStatus.canceled, userSubscriptionStatus.failed, userSubscriptionStatus.expired].includes(userSubscription?.status)
     || userSubscription?.isExpired), 'db-new': userSubscription?.category === UserSubscriptionCategory.STARTER || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE
    || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE_ULTIMATE  || userSubscription?.category === UserSubscriptionCategory.PROFESSIONAl || userSubscription?.category === UserSubscriptionCategory.PERSONAL || userSubscription?.category === UserSubscriptionCategory.PREMIUM }">
  <div class="db-payment-button__first">
    <div class="db-payment-button__info" *ngIf="userSubscription?.category === UserSubscriptionCategory.STARTER">
      <h1 class="db-payment-button__head" [style.font-size]="campaignInfo?.couponDays > 7 && '18px'">
        {{
          campaignInfo ? 'Try 10Web Pro with a ' +  (campaignInfo?.couponDays == 30 ? ' 1 month ' : campaignInfo?.couponDays + '-day') + ' free trial' : 'Get 10Web Pro plans for free'
        }}</h1>

      <p class="db-payment-button__desc" [innerHTML]="('text_starterFeature' | dbText: {couponDays: !!campaignInfo ? (campaignInfo?.couponDays == 30 ? ' 1 month' : campaignInfo?.couponDays + ' Days') : '7 Days'})"></p>
    </div>
  </div>
  <div class="db-payment-button__second"
       *ngIf="!userSubscription.trialClient"
       [dsTooltip]="activateAddOn"
       dsTooltipPosition="top"
       dsTooltipAlign="right"
       dsTooltipMode="hoverStatic"
       [dsTooltipVisible]="false">
    <a class="ds-btn-blue"
       (click)="buyNow()">
      <span>Buy Now</span>
    </a>
    <ng-template #activateAddOn>
      <div class="db-activate-add-ons">
        <p>Add additional website</p>
        <span><a class="text-underline" (click)="activateAddOns.emit()">Activate your add-ons</a> to add more hosted websites to your plan.</span>
      </div>
    </ng-template>
  </div>
  <div class="db-payment-button__second trial-client"
       *ngIf="userSubscription?.category === UserSubscriptionCategory.STARTER">
    <a class="ds-btn-blue" [ngClass]="{'ds-btn-l': !userSubscription?.trialBoosterClient}"
       (click)="sendFreeUpgradeEvent()">
      <span>{{'Get Pro Plans for Free' | lowerCaseSpecificWords}}</span>
    </a>
  </div>
</div>

